import { render } from "./QaSegment.vue?vue&type=template&id=4971dd66"
import script from "./QaSegment.vue?vue&type=script&lang=js"
export * from "./QaSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__